'use strict';

/**
 * Overlay for changing the status of objects
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var ChangeStatusListView = require('../partials/change-status-list');
var ChangeStatusRecipientItemView = require('../partials/change-status-recipient-item');

var template = require('modules/collection/templates/layout/change-status-overlay.hbs');

var ChangeStatusOverlayLayout = LayoutView.extend({
    template: template,

    viewData: {
        /**
         * Returns the number of selected items
         * @returns {number}
         */
        selectedObjects: function() {
            return this.getOption('model') || this.collection
                ? this.getOption('model') ? 1 : this.collection.selectedCount()
                : 0;
        },

        /**
         * Returns the current mode
         * @returns {string} The current mode
         */
        mode: function() {
            return this.getOption('mode') === 'select' ? 'select' : 'edit';
        },
    },

    regions: {
        statusMainRegion: '#region-status-main',
        statusRecipientRegion: '#region-status-recipient',
    },

    ui: {
        actionCancel: '[data-action="cancel"]',
        lanesComponent: '.vertical-lanes',
        lane: '.lane',
    },

    events: {
        'click @ui.actionCancel': 'onActionCancel',
        'click @ui.lane': 'onClickLane',
    },

    childEvents: {
        'status:selected': 'onSelectStatus',
        'status:goto': 'onGotoStatus',
    },

    /**
     * Current level of listing
     * @type {number}
     */
    currentLevel: 0,

    /**
     * Max level
     * @type {number}
     */
    maxLevel: 1,

    /**
     * Reference of the status collection
     * @type {Colido.Collection}
     */
    statusListView: null,

    onBeforeShow: function() {
        this.statusListView = new ChangeStatusListView({
            collection: App.CollectionModule.statusCollection,
        });

        this.statusMainRegion.show(this.statusListView);
    },

    /**
     * Closes the modal
     * @param {object} event The click event from the button
     */
    onActionCancel: function(event) {
        this.trigger('close:modal');
    },

    /**
     * Is triggered, when a lane is clicked. We will go back to the clicked lane
     * @param {object} event The click event
     */
    onClickLane: function(event) {
        var $curTarget = $(event.currentTarget);
        if (this.currentLevel > $curTarget.data('level') &&
            !$(event.target).parents('.list').length
        ) {
            this.setLevel($curTarget.data('level'));
        }
    },

    /**
     * Is triggered, when a status can have a recipient
     * @param {SetModule.SelectSetSetsListItemView} childView The child, that triggered the event
     * @param {number}                              level     Level of the childview
     * @param {CollectionModule.StatusModel}        model     The relevant model
     */
    onGotoStatus: function(childView, level, model) {
        if (level == this.currentLevel) {
            this.setLevel(level + 1, model);
        } else if (level < this.currentLevel) {
            this.setLevel(level);
        }
    },

    /**
     * Is triggered, when a set has been selected in child view
     * We will update the storage information of the selected items
     * @param {SetModule.SelectSetSetsListItemView} childView The child, that triggered the event
     * @param {number}                              level     Level of the childview
     * @param {CollectionModule.StatusModel}        model     The relevant model
     * @param {string=}                             recipient (Optional) Recipient for status
     */
    onSelectStatus: function(childView, level, model, recipient) {
        recipient = recipient || '';

        if (level == this.currentLevel) {
            if (this.getOption('mode') === 'select') {
                this.trigger('close:modal');
            } else {
                this.trigger('close:modal', {
                    statusModel: model,
                    recipient: recipient,
                });
            }
        } else if (level < this.currentLevel) {
            this.setLevel(level);
        }
    },

    /**
     * Sets a new level for the component
     * @param {number}  newLevel The level to set
     * @param {object=} model    (Optional) Related model for the new level
     */
    setLevel: function(newLevel, model) {
        // Destroy other regions
        if (newLevel < this.currentLevel) {
            this.statusRecipientRegion.empty();
        }

        // Is new level valid?
        if (newLevel <= this.maxLevel) {
            // Update ui
            this.currentLevel = newLevel;
            this.ui.lanesComponent.attr('data-level', newLevel);

            // Do we have a model?
            if (model) {
                var recipientView = new ChangeStatusRecipientItemView({
                    model: model,
                });

                this.statusRecipientRegion.show(recipientView);
            }
        }
    },

});

module.exports = ChangeStatusOverlayLayout;